import visa from '@/common/images/common/creditCards/visa.svg';
import mastercard from '@/common/images/common/creditCards/mastercard.svg';
import amex from '@/common/images/common/creditCards/amex.svg';
import discover from '@/common/images/common/creditCards/discover.svg';
import paypal from '@/common/images/common/creditCards/payment-paypal.png';
// import wechatPay from '@/common/images/oem/reolink-cn/homepage/wechat-pay.png';
import alipay from '@/common/images/oem/reolink-cn/homepage/alipay.png';

export default {
    
    all: {

        paypal: 'paypal',
        visa: 'visa',
        mastercard: 'mastercard-1',
        amex: 'american-express',
        discover: 'discover'

    },
    Paypal: {

        main: paypal,
        support: {

            visa,
            mastercard,
            amex,
            discover
            
        }
        
    },
    cn: {
        // wechat: wechatPay,
        alipay: alipay
    }

};



// WEBPACK FOOTER //
// ./src/config/paymentMethods.js